
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Significantly increase stale time to reduce unnecessary refetching
      staleTime: 30 * 60 * 1000, // 30 minutes (up from previous value)
      // Disable automatic refetching
      refetchOnWindowFocus: false,
      refetchOnReconnect: false, 
      refetchOnMount: false,
      refetchInterval: false,
      // Configure error retries
      retry: 1,
      retryDelay: 1000,
      // React Query v5 uses gcTime instead of cacheTime (v4)
      gcTime: 60 * 60 * 1000, // 60 minutes (doubled from previous value)
    }
  }
});

